import type { MomentFormMoment } from "../../../../modules/moment/types/moment-form-moment";
import {
  type PollWithOptionsResults,
  SupabasePollService,
} from "../../../../modules/poll/server/supabase-poll-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../server/supabase/hooks/types";

export const useMomentPollsResults = (
  moment: MomentFormMoment,
): UseSupabaseLoaderState<PollWithOptionsResults[]> => {
  const { poll_ids } = moment;

  return useSupabaseLoader(
    async ({ supabase }) => {
      if (!poll_ids || !poll_ids.length) return [];

      const result = await new SupabasePollService(supabase).getPollsWithOptionsResults(poll_ids);
      if (result.error) {
        throw new Error("Error fetching poll results");
      }
      return result.data;
    },
    [poll_ids],
  );
};
